import { render, staticRenderFns } from "./updataproduct.vue?vue&type=template&id=cddfceba&scoped=true&"
import script from "./updataproduct.vue?vue&type=script&lang=js&"
export * from "./updataproduct.vue?vue&type=script&lang=js&"
import style0 from "./updataproduct.vue?vue&type=style&index=0&id=cddfceba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cddfceba",
  null
  
)

export default component.exports